import { PROMOTION_CREDIT_CONSTRAINTS } from './constraints.js';
export const promotionCreditLinesMessage = `A credit can have at most ${PROMOTION_CREDIT_CONSTRAINTS.lines.max} lines.`;
//# sourceMappingURL=lines-message.js.map